import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { FileRecord } from '../entities/records';
import * as selectors from '../entities/File/selectors';

function mapStateToProps(state, { fileIds }) {
  return {
    files: selectors.filesByIds(state, fileIds),
  };
}

export default compose(
  setPropTypes({
    fileIds: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
  }),
  connect,
  setPropTypes({
    files: PropTypes.arrayOf(PropTypes.instanceOf(FileRecord)),
  }),
)(mapStateToProps);
